import { Box, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { fleetTotals } from './health';

/**
 * What the scraper fleet has built and done, across the whole window.
 *
 * The per-run tiles below answer "is the last sweep healthy". They cannot answer "what does this
 * system do", which is the first question anyone outside the team asks, and reporting one sweep in
 * isolation understates the fleet by the number of runs.
 */
export const FleetSummary = _ref => {
  let runs = _ref.runs;
  const fleet = fleetTotals(runs);
  if (!fleet.runs) return null;
  const stats = [{
    label: 'Scrapers built',
    value: fleet.scrapersBuilt,
    hint: 'Python, one per utility portal'
  },
  // Sweeps, not days. /health takes its `days` argument as a Take over the run documents in S3,
  // so it answers with the latest N runs whatever span they cover, and the sweep is sharded so
  // several runs can land the same day. Labelling it "in 30 days" stated a window nothing
  // measures; fleet.runs is the number actually summed.
  {
    label: 'Bills fetched',
    value: fleet.billsFetched,
    hint: "across the last ".concat(fleet.runs, " ").concat(fleet.runs === 1 ? 'sweep' : 'sweeps')
  }, {
    label: 'Providers swept',
    value: fleet.providersSwept,
    hint: "".concat(fleet.providersHealthy, " healthy on the last run")
  }, {
    label: 'Needing a person',
    value: fleet.needingAPerson,
    // action_required is a flag the scraper publishes per provider, not a classified reason, so
    // it covers a bad configuration as much as a rejected login. Naming only credentials and MFA
    // sent an operator to reset a password for a provider that was misconfigured.
    hint: fleet.needingAPerson ? 'credential, MFA or configuration failures' : 'no logins are blocked'
  }];
  return /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: '20px',
      marginBottom: '16px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "The scraper fleet"), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: "24px",
    flexWrap: "wrap",
    useFlexGap: true
  }, stats.map(stat => /*#__PURE__*/React.createElement(Box, {
    key: stat.label,
    sx: {
      minWidth: 180
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    sx: {
      fontVariantNumeric: 'tabular-nums'
    }
  }, stat.value.toLocaleString()), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, stat.label), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "text.secondary"
  }, stat.hint)))));
};